<template>
  <div id='kb-main'>
    <!-- <span>知识库</span> -->
    <el-form ref="form" :model="article">
      <el-row>
        <el-col :span="17">
          <el-input v-model="article.title" placeholder="标题"></el-input>
        </el-col>
        <el-col :span="7">
          <el-button v-if="isSaveVisible" @click="doUpdate">保存</el-button>
          <el-button @click="toggleSettings">设置</el-button>
          <el-button v-if="isSaveVisible" @click="preview">预览</el-button>
        </el-col>
      </el-row>
      <el-form-item v-if="showSettings">
        <el-col :span="5">
          <span style="float: left; margin-right: 10px;">推荐首页:</span>
          <el-radio v-model="article.recommend" :label="true">是</el-radio>
          <el-radio v-model="article.recommend" :label="false">否</el-radio>
        </el-col>
        <el-col :span="5">
          <span style="float: left; margin-right: 10px;">置顶:</span>
          <el-radio v-model="article.top" :label="true">是</el-radio>
          <el-radio v-model="article.top" :label="false">否</el-radio>
        </el-col>
        <el-col :span="5">
          <span style="float: left; margin-right: 10px;">立即发布:</span>
          <el-radio v-model="article.published" :label="true">是</el-radio>
          <el-radio v-model="article.published" :label="false">否</el-radio>
        </el-col>
        <el-col :span="7">
          <span style="float: left; margin-right: 10px;">编辑器:</span>
          <el-radio v-model="article.markdown" :label="false">HTML</el-radio>
          <el-radio v-model="article.markdown" :label="true">MarkDown</el-radio>
        </el-col>
        <el-input type="textarea" v-model="article.summary" placeholder="摘要"></el-input>
      </el-form-item>
      <div style="margin-bottom: 5px;">
        <span style="float: left; margin-right: 10px;">所属分类:</span>
        <el-checkbox-group v-model="article.categories" @change="handleCheckedCategoriesChange">
          <el-checkbox v-for="category in categories" :label="category.id" :key="category.id">{{ category.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      
    </el-form>
    <!-- https://github.com/hinesboy/mavonEditor -->
    <mavon-editor
      style="height: calc(100% - 120px);"
      v-if="article.markdown"
      v-model="article.content"
      ref="md"
      @imgAdd="$imgAdd"
    ></mavon-editor>
    <!-- <tinymce :height="800" v-model="currentArticle.content"></tinymce> -->
    <!-- https://www.kancloud.cn/liuwave/quill/1434141 -->
    <quill-editor
      v-if="!article.markdown"
      v-model="article.content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    >
    </quill-editor>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import bus from '@/util/eventbus'
const constants = require('@/util/constants')
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//
import { quillEditor, Quill } from 'vue-quill-editor'
// container,
import { ImageExtend, QuillWatch } from 'quill-image-extend-module'
// import { container, ImageExtend, QuillWatch } from 'quill-image-paste-module'
// 拖拽上传
// import { ImageDrop } from 'quill-image-drop-module'
// 调整上传图片大小
import ImageResize from 'quill-image-resize-module'
// 粘贴图片上传
// import { ImageExtend } from 'quill-image-paste-module'

// Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/imageExtend', ImageExtend)

export default {
  name: 'kb-main',
  data() {
    return {
      showSettings: false,
      initArticle: {
        id: 0,
        aid: '',
        title: '',
        recommend: false,
        top: false,
        published: false,
        categories: [],
        summary: '',
        markdown: false,
        content: '',
        attachments: [],
        type: constants.CATEGORY_TYPE_SUPPORT
      },
      article: {
        id: 0,
        aid: '',
        title: '',
        recommend: false,
        top: false,
        published: false,
        categories: [],
        summary: '',
        markdown: false,
        content: '',
        attachments: [],
        type: constants.CATEGORY_TYPE_SUPPORT
      },
      // 富文本框参数设置
      editorOption: {
        modules: {
          // imageDrop: true,
          imageResize: {},
          // imageResize: {
          //   displayStyles: {
          //     backgroundColor: 'black',
          //     border: 'none',
          //     color: 'white'
          //   },
          //   modules: ['Resize', 'DisplaySize', 'Toolbar'] // Resize 允许缩放， DisplaySize 缩放时显示像素 Toolbar 显示工具栏
          // },
          // imageExtend: {},
          imageExtend: {
            // 如果不作设置，即{} 则依然开启复制粘贴功能且以base64插入
            loading: true, // 可选参数 是否显示上传进度和提示语
            name: 'file', // 图片参数名
            size: 3, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: constants.UPLOAD_IMAGE_URL, // 服务器地址, 如果action为空，则采用base64插入图片
            // response 为一个函数用来获取服务器返回的具体图片地址
            // 例如服务器返回{code: 200; data:{ url: 'baidu.com'}}
            // 则 return res.data.url
            response: res => {
              return res.data
            },
            headers: xhr => {
              // xhr.setRequestHeader('username', '')
            }, // 可选参数 设置请求头部
            // sizeError: () => {}, // 图片超过大小的回调
            // start: () => {}, // 可选参数 自定义开始上传触发事件
            // end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            // error: () => {}, // 可选参数 上传失败触发的事件
            // success: () => {}, // 可选参数  上传成功触发的事件
            change: (xhr, formData) => {
              // xhr.setRequestHeader('username', '')
              let filename = moment(new Date()).format('YYYYMMDDHHmmss') + '.png'
              formData.append('file_name', filename)
              formData.append('username', '')
            } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
          },
          // clipboard: {
          //   // 粘贴版，处理粘贴时候带图片
          //   matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]]
          // //   matchers: [
          // //     ['img', this.handleCustomMatcher]
          // //   ]
          // },
          toolbar: {
            // 如果不上传图片到服务器，此处不必配置
            // container: container, // container为工具栏，此次引入了全部工具栏，也可自行配置
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              [{ indent: '-1' }, { indent: '+1' }], // 左右缩进
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ align: [] }], // 对齐方式
              ['link', 'image'] // 'video'上传图片、上传视频
            ],
            handlers: {
              image: function() {
                // 劫持原来的图片点击按钮事件
                QuillWatch.emit(this.quill.id)
                // 劫持图片上传，自定义图片上传
                // if (value) {
                //   // 通过input的type=file唤醒选择弹框，选择之后自定义上传路径
                //   document.querySelector('#input').click()
                // } else {
                //   this.quill.format('image', false)
                // }
              }
            }
          }
        },
        // theme: 'snow', // 主题
        placeholder: '请输入正文'
      }
    }
  },
  watch: {
    currentArticle(newArticle, oldArticle) {
      // console.log('watch current article: ', newArticle, oldArticle)
      // this.article = Object.assign(newArticle, {})
      // if (this.article.id === oldArticle.id) {
      //   if (this.article.title !== oldArticle.title
      //     || this.article.summary !== oldArticle.summary
      //     || this.article.content !== oldArticle.content
      //     || this.article.markdown !== oldArticle.markdown
      //     || this.article.recommend !== oldArticle.recommend
      //     || this.article.published !== oldArticle.published
      //     || this.article.categories !== oldArticle.categories
      //     || this.article.attachments !== oldArticle.attachments) {
      //     // TODO: 保存
      //     console.log('update article:', this.article)
      //     // this.updateArticle(this.article)
      //   }
      // }
      let categoriesIds = []
      for (let i = 0; i < newArticle.categories.length; i++) {
        const element = newArticle.categories[i]
        categoriesIds.push(element.id)
      }
      // 此article用来保存初始内容，内容不变
      // this.initArticle.id = newArticle.id
      // this.initArticle.aid = newArticle.aid
      // this.initArticle.title = newArticle.title
      // this.initArticle.summary = newArticle.summary
      // this.initArticle.content = newArticle.content
      // this.initArticle.markdown = newArticle.markdown
      // this.initArticle.recommend = newArticle.recommend
      // this.initArticle.top = newArticle.top
      // this.initArticle.published = newArticle.published
      // this.initArticle.categories = categoriesIds
      // this.initArticle.attachments = newArticle.attachments
      // 此article同步修改article，内容更新
      this.article.id = newArticle.id
      this.article.aid = newArticle.aid
      this.article.title = newArticle.title
      this.article.summary = newArticle.summary
      this.article.content = newArticle.content
      this.article.markdown = newArticle.markdown
      this.article.recommend = newArticle.recommend
      this.article.top = newArticle.top
      this.article.published = newArticle.published
      this.article.categories = categoriesIds
      this.article.attachments = newArticle.attachments
      // console.log('new article:', this.article)
      
    }
  },
  components: { quillEditor },
  computed: {
    ...mapGetters("knowledgebase", ['categories', 'articles', 'currentArticle', 'currentCategory', 'knowledgebase']),
    isSaveVisible() {
      return this.article.id !== 0
    },
  },
  methods: {
    ...mapActions("knowledgebase", ['createArticle', 'updateArticle', 'updateCurrentArticle', 'getArticlesSupport']),
    handleSuccess(response) {
      // this.isLoading = false
      console.log('handleSuccess:', response)
      this.$message({
        message: '保存成功',
        type: 'success'
      });
    },
    handleFailed(error) {
      // this.isLoading = false
      console.log('handleFailed:', error)
      this.$message.error('保存失败');
    },
    doUpdate() {
      if (this.article.id === 0) {
        return
      }
      if (this.article.categories.length === 0) {
        this.$message({
          message: '请至少选择一个分类',
          type: 'warning'
        });
        return
      }
      let payload = { article: this.article, successcb: this.handleSuccess, failedcb: this.handleError }
      this.updateArticle(payload)
    },
    toggleSettings() {
      this.showSettings = !this.showSettings
    },
    preview() {
      if (this.article.aid === '') {
        this.$message.info('请先选择文章')
        return
      }
      // console.log(article)
      if (constants.IS_PRODUCTION) {
        window.open('https://' + this.knowledgebase.subDomain + '.docs.bytedesk.com/article_' + this.article.aid + '.html')
      } else {
        window.open('http://127.0.0.1:8887/article_' + this.article.aid + '.html')
      }
    },
    onEditorBlur(quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      // console.log('editor ready!', quill)
      // this.quill = quill
      this.initEditorListener(quill)
    },
    initEditorListener(quill) {
      //  自定义粘贴图片功能
      // let quill = this.$refs.myQuillEditor.quill
      // this.$forceUpdate()
      quill.root.addEventListener(
        'paste',
        evt => {
          if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
            console.log('addEventListener - paste')
            evt.preventDefault()
            ;[].forEach.call(evt.clipboardData.files, file => {
              if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                return
              }
              // console.log('file:', file)
              this.uploadImage(quill, file)
            })
          }
        },
        false
      )
    },
    uploadImage(quill, file) {
      //
      let filename = moment(new Date()).format('YYYYMMDDHHmmss')
      if (file.type === 'image/jpeg') {
        filename = filename + '.jpg'
      } else if (file.type === 'image/png') {
        filename = filename + '.png'
      }
      // //
      // var formdata = new FormData()
      // formdata.append('file_name', filename)
      // formdata.append('username', this.userInfo.username)
      // formdata.append('file', file)
      // // formdata.append("client", 'web');
      // const messageLoading = this.$message.loading('上传中..', 0)
      // // let app = this
      // $.ajax({
      //   url: this.uploadImageServerUrl,
      //   contentType: false,
      //   cache: false,
      //   processData: false,
      //   mimeTypes: 'multipart/form-data',
      //   type: 'post',
      //   data: formdata,
      //   success: function(response) {
      //     setTimeout(messageLoading, 100)
      //     // console.log('upload response:', response.data)
      //     var imageUrl = response.data
      //     let length = quill.getSelection().index // 光标位置
      //     // 插入图片  图片地址
      //     quill.insertEmbed(length, 'image', imageUrl)
      //     // 调整光标到最后
      //     quill.setSelection(length + 1) // 光标后移一位
      //   },
      //   error: function(error) {
      //     setTimeout(messageLoading, 100)
      //     console.log(error)
      //   }
      // })
    },
    handleCheckedCategoriesChange(value) {
      // console.log('handleCheckedCategoriesChange:', value)
      this.article.categories = value
    },
    // 绑定@imgAdd event
    // https://github.com/hinesboy/mavonEditor/blob/master/doc/cn/upload-images.md
    $imgAdd(pos, $file) {
      // 第一步.将图片上传到服务器.
      let filename = moment(new Date()).format('YYYYMMDDHHmmss')
      if ($file.type === 'image/jpeg') {
        filename = filename + '.jpg'
      } else if ($file.type === 'image/png') {
        filename = filename + '.png'
      }
      //
      var formdata = new FormData()
      formdata.append('file_name', filename)
      formdata.append('username', this.userInfo.username)
      formdata.append('file', $file)
      //
      const messageLoading = this.$message.loading('上传中..', 0)
      let app = this
      $.ajax({
        url: this.uploadImageServerUrl,
        contentType: false,
        cache: false,
        processData: false,
        mimeTypes: 'multipart/form-data',
        type: 'post',
        data: formdata,
        success: function(response) {
          setTimeout(messageLoading, 100)
          // maven upload response: https://bytedesk.oss-cn-shenzhen.aliyuncs.com/images/20220427231637.png
          // console.log('maven upload response:', response.data)
          var imageUrl = response.data
          // 第二步.将返回的url替换到文本原位置![...](0) -> ![...](url)
          /**
           * $vm 指为mavonEditor实例，可以通过如下两种方式获取
           * 1. 通过引入对象获取: `import {mavonEditor} from ...` 等方式引入后，`$vm`为`mavonEditor`
           * 2. 通过$refs获取: html声明ref : `<mavon-editor ref=md ></mavon-editor>，`$vm`为 `this.$refs.md`
           */
          app.$refs.md.$img2Url(pos, imageUrl)
        },
        error: function(error) {
          setTimeout(messageLoading, 100)
          console.log(error)
        }
      })
    },
  }

}
</script>

<style scoped>
#kb-main {
  /* padding-left: 10px; */
  /* padding-top: 50px; */
  text-align: left;
  height: 100%;
  width: 100%;
}
.quill-editor {
  height: calc(100% - 80px);
  margin-bottom: 50px;
  background: white;
}
.tox-tinymce {
  height: 95% !important;
}
</style>
